import { Component } from 'react';
import Table from 'scripts/components/Table';
import Loading from 'scripts/components/Loading';
import { dataRefreshTime, apiBaseUrl } from 'scripts/config';
import { isValidCountry, getCookie, mapCountryCode } from 'scripts/utils';
import $ from 'jquery';
import _ from 'lodash';
import styles from 'styles/content';

export default class AllMedals extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	componentWillMount() {
		this._geoCountry = mapCountryCode(getCookie('countryCode'));
	}

	componentDidMount() {
		this.getData();

		if (dataRefreshTime) {
			this.interval = setInterval(this.getData.bind(this), dataRefreshTime);
		}
	}

	componentWillUnmount() {
		this.interval = clearInterval(this.interval);
	}

	getData() {
		const dataUrl = `${__DEV__ ? 'scripts/mocks' : `${apiBaseUrl}/results`}/country.json`;

		this.request = $.getJSON(dataUrl, ({ countries: medals }) => {
			const newState = {medals};

			if (this._geoCountry) {
				const validCountryMedals = medals.filter(({ country }) => isValidCountry(country));
				const userCountryMedals = _.find(validCountryMedals, {country: this._geoCountry});

				if (userCountryMedals) {
					userCountryMedals.position = _.findIndex(validCountryMedals, {country: this._geoCountry}) + 1;
					newState.userCountryMedals = userCountryMedals;
				}
			}

			this.setState(newState);
		});
	}

	isLoaded() {
		return this.request
			&& this.request.state() === 'resolved';
	}

	render() {
		return (
			<div className={styles.panel}>
				<div className={styles.panelTop}>
					<span className={styles.title}>Medals</span>
				</div>

				{this.isLoaded()
					? <Table type="list" content={this.state.medals} contentHighlight={this.state.userCountryMedals} />
					: <Loading />}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./scripts/components/AllMedals.es6